import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { Grupo } from 'src/app/models/api/comercial/grupo';
import { IResponse } from 'src/app/models/api/response.interface';

@Injectable({
  providedIn: 'root'
})
export class ApiGrupoService {
  private baseUrl = 'Grupo';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<Grupo[]>('');
  }
  getAllAtivosInativos() {
    return this.controller.useLoading('waves').get<IResponse<Grupo[]>>('/BuscarAtivosInativos');
  }
  insert(data: Grupo) {
    return this.controller.useLoading().post('', data);
  }

  update(data: Grupo) {
    return this.controller.useLoading().put('', data);
  }

  delete(id: string) {
    if (!id) { throw new Error('Invalid Argument'); }
    return this.controller.useLoading().delete(id);
  }
}
